/**
 * Component   : UserManagement
 * Description : Adding a new User
 */
import { Card, CardContent, CardHeader, Divider, Grid, Paper, Typography } from "@mui/material";
import { TreeViewBaseItem } from '@mui/x-tree-view/models';
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { bindDropDown, callAPI, clearRequest, compressImageFile, customValidation, EPhone, formatPhoneNumber, handleApiError, Method, updateMainHeader, validations } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { IBranch } from "../../DTO/Dto";
import { HeaderList, IHeaderListActions } from "../../../Components/Header/HeaderList";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSPhone from "../../../Components/Phone/WSPhone";
import WSImageUpload from "../../../Components/FileUpload/WSImageUpload";
import config from '../../../Config/config.json'
import http from "../../../commonFunctions/httpClient";
export const Branch: React.FC<any> = React.memo((props) => {
    const { showMessage } = useSnackbar();
    const { register, handleSubmit, control, setValue, watch, reset, getValues } = useForm();
    const navigate = useNavigate();
    const [userPermissions, setUserPermissions] = useState<any>([]);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [imageUrl, setImageUrl] = useState<any>([]);
    const params = useParams()
    const id = params?.id;
    useEffect(() => {
        updateMainHeader("Add Branch");
        breadCrumbsStore.updateBreadCrumbs([
            { "Branch": "/branch/list" },
            { [id ? 'Edit' : "Create"]: `` },
        ]);
        setValue('state', 'Kerala')
    });
    useEffect(() => () => {
        reset()
    }, [])
    useEffect(() => {
        /**
         * Method to get the user record by id for edit purpose
         * @param id 
         */
        async function getBranchById(id: any): Promise<void> {
            try {
                const response: any = await callAPI('Branch', Method.GET, {}, id);

                if (response && response.data) {
                    if (response.data.permissions) {
                        setUserPermissions(response.data.permissions)
                    }
                    for (const field in response.data) {
                        if (field === 'phoneNumber') {
                            setValue(field, formatPhoneNumber((response?.data as any)[field], EPhone.AddHyphen))
                        } else if (field === "logoUrl") {
                            setImageUrl(
                                `${config.imgUrl}${response?.data[field].replace(
                                    "uploads/",
                                    ""
                                )}`
                            );
                        }
                        else {
                            setValue(field, (response?.data as any)[field]);
                        }
                    }
                }
            } catch (error) {
                showMessage('Error fetching user:', 'error');
            }
        }
        if (id) {
            getBranchById(id);
        }
    }, [id]);

    const handleCancelClick = () => {
        navigate("/branch/list");
    };
    /**
     * Method for Add/Update the data
     * @param data 
     */
    const onSubmit = async (data: any) => {
        try {
            setLoading(true)
            const request: any = await setRequest(data);

            if (id) {
                const response: any = await http.putFormData(`Branch?id=${id}`,request) //callAPI(`Branch/${id}`, Method.PUTFORMDATA, null, null, request);
                if (response?.errors) {
                    const mess = handleApiError(response)
                    showMessage(mess, 'error');
                }
                else if (response) {
                    showMessage(response?.message, response.success === true ? "success" : "error");
                    response.success === true && navigate("/branch/list");
                }
            } else {
                const response: any = await callAPI('Branch', Method.POSTFORMDATA, null, null, request);

                if (response?.errors) {
                    const mess = handleApiError(response)
                    showMessage(mess, 'error');
                }
                else if (response) {
                    showMessage(response?.message, response.success === true ? "success" : "error");
                    response.success === true && navigate("/branch/list");
                }
            }
        } catch (e: any) {
            showMessage(e.error);
        }
        finally {
            setLoading(false)
        }
    };
    const handleUploadChange = async (uploadedFile: any) => {
        try {
            let newFile: any = await compressImageFile(uploadedFile);
            setSelectedFile(newFile);
        } catch (error) {
            showMessage("Error converting file to base64:", "error");
        }
    };
    /**
     * Method to set the request for the user
     * @param data 
     * @returns 
     */
    const setRequest = async (data: any) => {
        try {

            const formData = new FormData();
            if (selectedFile) {
                formData.append("logoUrl", selectedFile!);
            }
            formData.append("Name", data?.name);
            formData.append(
                "PhoneNumber",
                formatPhoneNumber(data?.phoneNumber, EPhone.RemoveHyphen)
            );
            const address = {

            }
            formData.append("Address.AddressLine1", data.address.addressLine1);
            if (data.address.addressLine2 !== "") {
                formData.append("Address.AddressLine2", data.address.addressLine2);
            }
            formData.append("Address.City", data.address.city);
            formData.append("Address.State", data.address.state);
            formData.append("Address.Pincode", data.address.pincode);
            formData.append("Email", data?.email);
            formData.append("BranchCode", String(data?.branchCode ?? ''));
            formData.append("GstNumber", data?.gstNumber);
            formData.append("AlternatePhoneNumber", data?.alternatePhoneNumber);


            return formData;
        } catch (e: any) {
            showMessage(e.error);
        }
    };

    const actions: IHeaderListActions[] =
        [
            { type: 'button', text: 'Cancel', size: 'small', onClick: handleCancelClick, variant: 'outlined', color: 'primary' },
            { type: 'button', text: 'Save', size: 'small', loading: loading, buttonType: 'submit', variant: 'outlined', color: 'primary' }
        ]

    return (

        <>       <form onSubmit={handleSubmit(onSubmit)}>
            <HeaderList title={!id ? "Add Branch" : "Update Branch"} isBackButton={true} url="/branch/list" type="card" actions={actions} isDivider headerSx={{ height: 50 }} />

            <Paper elevation={3} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, border: '1px solid #ccc', borderRadius: '8px' }}>


                <Grid xs={12} className="modal-input" container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item sm={12} xs={12}>
                        <Typography sx={{ fontSize: '0.875rem', fontWeight: "bold" }} color={'gray'}>Branch Information</Typography>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="name" name="name" rules={{ required: true }} label=" Name *"></WSTextField>

                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="gstNumber" name="gstNumber" rules={{ required: true }} label="GST No"></WSTextField>
                    </Grid>

                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="email" name="email" rules={customValidation(true, validations.email)} label="Email *"></WSTextField>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSPhone label="Phone" rules={{ required: false }} control={control} id="phoneNumber" {...register('phoneNumber')} name="phoneNumber"></WSPhone>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField label="Alternate Phone" rules={{ required: false }} control={control} id="alternatePhoneNumber" name="alternatePhoneNumber"></WSTextField>
                    </Grid>

                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="branchCode" rules={{ required: true }} minLength={2} type={TextType.AllowOnlyNumber} name="branchCode" label="Branch Code" disabled={id ? true : false}></WSTextField>
                    </Grid>



                </Grid>
                <Grid container spacing={2} mt={0}>
                    <Grid item sm={12} xs={12}>
                        <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }} color={'gray'}>
                            Address Information
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <WSTextField
                            control={control}
                            id="addressLine1"
                            name="address.addressLine1"
                            rules={{ required: true }}
                            label="Address Line1 *"
                        ></WSTextField>
                    </Grid>
                    <Grid item xs={6}>
                        <WSTextField
                            control={control}
                            id="addressLine2"
                            name="address.addressLine2"
                            rules={{ required: false }}
                            label="Address Line2 "
                        ></WSTextField>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <WSTextField
                            control={control}
                            id="state"
                            name="address.state"
                            rules={{ required: true }}
                            label="State *"
                        ></WSTextField>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <WSTextField
                            control={control}
                            id="city"
                            name="address.city"
                            rules={{ required: true }}
                            label="City *"
                        ></WSTextField>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <WSTextField
                            control={control}
                            id="pincode"
                            name="address.pincode"
                            rules={{ required: true }}
                            label="Pincode *"
                            maxLength={6}
                        ></WSTextField>
                    </Grid>
                </Grid>
                <Grid container spacing={2} mt={0}>
                    <Grid item sm={12} xs={12}>
                        <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }} color={'gray'}>
                            Logo
                        </Typography>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item>
                                <WSImageUpload
                                    control={control}
                                    id="logoUrl"
                                    name="logoUrl"
                                    label=""
                                    rules={{ required: false }}
                                    onChange={handleUploadChange}
                                // imgUrl={imageUrl}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>

            </Paper>
        </form>
        </>
    );
});
